import { t, tEn, tZh } from '../i18n';
import { logQuestion } from '../questions-client';
import { setListening } from '../sea';
import type { DisposableScreen } from '../types';
import { STORAGE_KEYS } from './settings';

export interface HomeResult {
  question: string; // '' if general
  isGeneral: boolean;
}

export function mountHome(onSubmit: (r: HomeResult) => void): HTMLElement {
  const screen = document.createElement('section');
  screen.id = 'screen-question';
  screen.className = 'screen active';
  screen.innerHTML = `
    <div class="hero-title">
      <span lang="en"><em>${tEn('home.hero')}</em></span>
      <span lang="zh">${tZh('home.hero')}</span>
    </div>
    <div class="prompt-line">
      <span lang="en"><em>${tEn('home.subtitle')}</em></span>
      <span lang="zh">${tZh('home.subtitle')}</span>
    </div>

    <div class="question-box">
      <input class="question-input" id="question-input" />
      <div class="btn-row">
        <button class="begin-btn" id="begin-btn">
          <span lang="en">${tEn('home.begin')}</span>
          <span lang="zh">${tZh('home.begin')}</span>
        </button>
        <a class="general-link" id="skip-btn">
          <span lang="en"><em>${tEn('home.skip')}</em></span>
          <span lang="zh">${tZh('home.skip')}</span>
        </a>
      </div>
    </div>
  `;

  // Wire interactions
  const input = screen.querySelector('#question-input') as HTMLInputElement;
  input.placeholder = t('home.placeholder');

  // Window-level listeners must be cleaned up when the screen is replaced;
  // otherwise each navigation back to home leaks another pair.
  const ac = new AbortController();

  let calmTimer: ReturnType<typeof setTimeout> | null = null;
  const startListening = (): void => {
    setListening(true);
    if (calmTimer) clearTimeout(calmTimer);
    calmTimer = setTimeout(() => setListening(false), 900);
  };
  input.addEventListener('input', startListening, { signal: ac.signal });
  input.addEventListener('keydown', startListening, { signal: ac.signal });
  const onLangChange = (): void => {
    input.placeholder = t('home.placeholder');
  };
  window.addEventListener('linyuan:lang-change', onLangChange, { signal: ac.signal });

  screen.querySelector<HTMLButtonElement>('#begin-btn')?.addEventListener('click', () => {
    const q = input.value.trim();
    if (q) {
      const name = localStorage.getItem(STORAGE_KEYS.user) ?? '';
      void logQuestion(name, q);
    }
    onSubmit({ question: q, isGeneral: q.length === 0 });
  });

  screen.querySelector<HTMLAnchorElement>('#skip-btn')?.addEventListener('click', () => {
    onSubmit({ question: '', isGeneral: true });
  });

  (screen as DisposableScreen).dispose = () => {
    ac.abort();
    if (calmTimer) clearTimeout(calmTimer);
  };
  return screen;
}
